import { useParams } from "react-router-dom";
import ProfileForm from "../../components/Profile/ProfileForm";
import { useModal } from "../../hooks/use-modal.jsx";
import { Profile } from "../../models/profile";
import { useTenantProfiles } from "../../hooks/use-profiles-indiv";

export default function AddGarantPage({ withMandatoryFields }) {
  const [Modal, closeModal] = useModal(true);

  const { tenantId, profileId } = useParams();
  const { createProfile } = useTenantProfiles(tenantId);

  return (
    <ProfileForm
      withMandatoryFields={withMandatoryFields}
      isGarant
      modal={Modal}
      onSubmit={async (data) => {
        const profile = Profile.create(data);
        profile.garantor_of = parseInt(profileId);
        await createProfile(profile);
        closeModal();
      }}
    />
  );
}
